import { useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";
import Lightbox from "../components/Lightbox";
import { GALLERY, resolveImage } from "../data/content";

export default function Gallery({ items }) {
  const list = (Array.isArray(items) && items.length > 0 ? items : GALLERY).slice(0, 6);
  const [active, setActive] = useState(null);

  const move = (dir) =>
    setActive((a) => (a === null ? null : (a + dir + list.length) % list.length));

  return (
    <section id="gallery" data-testid="gallery-section" className="mx-auto max-w-7xl scroll-mt-20 px-6 py-24 sm:px-12 sm:py-32 lg:px-20 lg:py-40">
      <Reveal>
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-brass">Gallery</p>
      </Reveal>
      <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
        <Reveal delay={0.1}>
          <h2 className="max-w-2xl font-serif text-3xl font-light leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
            All footage &amp; images <span className="italic text-brass">taken at Jamoon.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <Link
            to="/gallery"
            data-testid="gallery-view-all-link"
            className="text-xs tracking-[0.25em] text-brass transition-colors duration-300 hover:text-ivory"
          >
            OPEN THE ARCHIVE →
          </Link>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-3">
        {list.map((g, i) => (
          <Reveal key={g.uri || g.image || i} delay={(i % 3) * 0.08}>
            <button
              data-testid={`gallery-item-${i}`}
              onClick={() => setActive(i)}
              className="group block w-full overflow-hidden focus:outline-none focus:ring-1 focus:ring-brass"
              aria-label={`Open image: ${g.caption}`}
            >
              <img
                src={resolveImage(g.uri || g.image, 800, 800)}
                alt={g.caption}
                loading="lazy"
                className="aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
            </button>
          </Reveal>
        ))}
      </div>

      <Lightbox items={list} index={active} onClose={() => setActive(null)} onNavigate={move} />
    </section>
  );
}
